<template>
    <div class="home pure-g">

        <StocktakingMenu :url="backUrl" class="pure-u-1-6"/>

        <div class="pure-u-5-6">

            <div class="menuBarBox">
                <div id="menuBar" class="pure-menu pure-menu-horizontal menuBar">
                    <li class="pure-menu-item"><a class="pure-menu-link" v-on:click="back()" >Zur&uuml;ck</a></li>
                    <li class="pure-menu-item"><a class="pure-menu-link" v-on:click="save()">Speichern</a></li>
                </div>
            </div>


            <div class="formBox">
                <form class="pure-form pure-form-stacked">
                    <fieldset>
                        <legend v-if="location">Fach {{ location.scanCode }} </legend>
                    </fieldset>

                    <div>
                        <textarea v-if="location" v-model="location.comment" style="width: 100%;"></textarea>
                    </div>
                    <div style="display:flex; flex-direction: row; justify-content: left; align-items: flex-start">
                        <input v-if="location" v-model="location.checked" style="margin-left: 5px;" id="locationChecked" type="checkbox" />
                        <label style="padding-left: 10px;" for="locationChecked">Fach gepr&uuml;ft</label>
                    </div>

                    <fieldset style="margin-top: 20px;">
                        <legend v-if="location">Erfassungen</legend>
                    </fieldset>
                    <div v-if="records" class="row">
                        <div class="col">
                            <div class="row">
                                <select v-on:change="onSelectedLeft" v-model="selectedLeft" >
                                    <option  v-for="record in records.data"
                                            :key="record._links.self.href"
                                            :value="record.uuid">
                                        Erfasst von: {{ record.staff }} am {{ new Date(record.createDate).toLocaleDateString('de-DE', dateOptions) }}
                                    </option>
                                </select>
                                <a v-if="selectedLeft" v-on:click="onDeleteLeft()" style="margin-top: 8px; margin-left: 8px;"><delete-icon fillColor="#ff4d4d"/></a>
                            </div>
                            <table v-if="comparedRecords" class="pure-table table">
                                <thead>
                                <tr>
                                    <th>Scan Code</th>
                                    <th>Zeit</th>
                                    <th>Wert</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in  comparedRecords.left "  class="even-odd"  style="height: 25px;">
                                    <td><span v-if="item">{{ item.scanCode }}</span></td>
                                    <td><span v-if="item" >{{ new Date(item.createDate).toLocaleDateString('de-DE', dateOptions) }}</span></td>
                                    <td><span v-if="item">{{ item.value }}</span></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col">
                            <div class="row">
                                <select v-on:change="onSelectedRight" v-model="selectedRight" >
                                    <option v-for="record in records.data"
                                            :key="record._links.self.href"
                                            :value="record.uuid">
                                        Erfasst von: {{ record.staff }} am {{ new Date(record.createDate).toLocaleDateString('de-DE', dateOptions) }}
                                    </option>
                                </select>
                                <a v-if="selectedRight" v-on:click="onDeleteRight()" style="margin-top: 8px; margin-left: 8px;"><delete-icon fillColor="#ff4d4d"/></a>
                            </div>
                            <table v-if="comparedRecords" class="pure-table table">
                                <thead>
                                <tr>
                                    <th>Scan Code</th>
                                    <th>Zeit</th>
                                    <th>Wert</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in  comparedRecords.right " class="even-odd" style="height: 25px;">
                                    <td><span v-if="item" >{{ item.scanCode }}</span></td>
                                    <td><span v-if="item" >{{ new Date(item.createDate).toLocaleDateString('de-DE', dateOptions) }}</span></td>
                                    <td><span v-if="item" >{{ item.value }}</span></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import StocktakingMenu from '@/components/StocktakingMenu'
    import axios from "axios"
    import router from '@/router.js'
    import { getJwt } from '@/utils/auth.js'
    import { toastInfo, toastError } from '@/utils/toast.js'
    import { getApiUrl } from '@/utils/api.js'
    import DeleteIcon from "vue-material-design-icons/delete";

    export default {
        name: 'EditLocationView',
        components: {
            StocktakingMenu,
            DeleteIcon
        },
        data: function () {
            return {
                url: null,
                backUrl: null,
                stocktaking: null,
                location: null,
                records: null,
                store: null,
                date: null,
                selectedLeft: null,
                selectedRight: null,
                comparedRecords: null,
                dateOptions: {  year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }
            }
        },
        created: function() {

            this.url = this.$route.params.url
            this.backUrl = this.$route.params.backUrl

            console.info("Back: " + this.backUrl)
        },
        mounted: function() {

            this.loadData(this.$route.params.url)
        },
        methods: {

            loadData: function (url) {

                axios({
                    method: "GET",
                    url: url,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + getJwt()
                    }
                }).then(
                    result => {
                        this.location = result.data
                    },
                    error => {
                        console.error(error.response.data.status)
                    }
                )

                axios({
                    method: "GET",
                    url: url + "/records",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + getJwt()
                    }
                }).then(
                    result => {
                        this.records = result.data
                        console.info(this.records)
                    },
                    error => {
                        console.error(error.response.data.status)
                    }
                )
            },
            onSelectedLeft: function() {

                console.info("Selected left: " + this.selectedLeft)
                this.loadCompare()
            },
            onSelectedRight: function() {

                console.info("Selected right: " + this.selectedRight)
                this.loadCompare();
            },
            onDeleteLeft: function() {

                axios({
                    method: "DELETE",
                    url: getApiUrl() + "/v0/records/" + this.selectedLeft ,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + getJwt()
                    }
                }).then(
                    result => {
                        toastInfo('Die Erfassung wurde gelöscht.')
                        this.selectedRight = null
                        this.selectedLeft = null
                        this.comparedRecords = null;
                        this.loadData(this.url)
                    },
                    error => {
                        console.error(error.response.data.status)
                    }
                )
            },
            onDeleteRight: function() {

                axios({
                    method: "DELETE",
                    url: getApiUrl() + "/v0/records/" + this.selectedRight ,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + getJwt()
                    }
                }).then(
                    result => {
                        toastInfo('Die Erfassung wurde gelöscht.')
                        this.selectedRight = null
                        this.selectedLeft = null
                        this.comparedRecords = null;
                        this.loadData(this.url)
                    },
                    error => {
                        console.error(error.response.data.status)
                    }
                )
            },
            loadCompare: function() {

                if (this.selectedLeft == null) return
                if (this.selectedRight == null) return

                axios({
                    method: "GET",
                    url: this.url + "/records/compare/" + this.selectedLeft + "/" + this.selectedRight ,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + getJwt()
                    }
                }).then(
                    result => {
                        this.comparedRecords = result.data
                    },
                    error => {
                        console.error(error.response.data.status)
                    }
                )
            },
            back: function() {

                router.push({
                    name: "editStocktakingView",
                    params: {
                        url: this.backUrl
                    }
                });
            },
            save: function() {

                axios({
                    method: 'PUT',
                    'url': this.url,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + getJwt()
                    },
                    data: {
                        checked: this.location.checked,
                        comment: this.location.comment
                    }
                })
                .then(
                    result => {
                        toastInfo('Das Fach wurde aktualisiert.')
                        console.info(result)
                    },
                    error => {
                        toastError(error.response.data.message)
                    }
                )
            }
        }
    }

</script>

<style>
    .row {
        display: flex; /* equal height of the children */
    }

    .col {
        flex: 1; /* additionally, equal width */
    }
</style>